import { Alert } from "react-bootstrap";

const AlertRecibosPagos = () => {
  return (
    <>
      <Alert variant="info">
        <ul>
          <li style={{ fontStyle: "italic" }}>Seleccione un rango para buscar recibos pagos.</li>
          <li style={{ fontStyle: "italic" }}>
            Si no selecciona ninguna fecha, se mostraran los recibos de los ultimos 30 días.
          </li>
          <li style={{ fontStyle: "italic" }}>
            Si se seleccionan fechas iguales, se mostraran todo los recibos pagos.
          </li>
          <li style={{ fontStyle: "italic" }}>
            {
              "Si se selecciona únicamente  'Fecha desde', se tendrían en cuenta los 30 días posteriores a la misma incluida."
            }
          </li>
          <li style={{ fontStyle: "italic" }}>
            {
              "Si se selecciona únicamente 'Fecha hasta', se tendrían en cuenta los 30 días previos a la misma."
            }
          </li>
        </ul>
      </Alert>
    </>
  );
};
export default AlertRecibosPagos;
